module.exports = {
  "country": "UA",
  "artist": "Verka Serduchka",
  "song": "Dancing Lasha Tumbai",
  "year": "2007",
  "place": "2",
  "spotify": "3ve2mVR6BkXuNWfHVoA5yu"
};